import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioDownloadLabelsRequestDto,
  NuvemEnvioDownloadLabelsResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioDownloadLabelsData,
  getNuvemEnvioDownloadLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  downloadNuvemEnvioLabel as downloadNuvemEnvioLabelAction,
  resetDownloadNuvemEnvioLabel as resetDownloadNuvemEnvioLabelAction,
} from '../../ordersSlice/ordersSlice';

export interface UseDownloadNuvemEnvioLabelResult {
  downloadNuvemEnvioLabel: (
    params: NuvemEnvioDownloadLabelsRequestDto,
  ) => Promise<NuvemEnvioDownloadLabelsResponseDto>;
  data: NuvemEnvioDownloadLabelsResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
  resetDownloadNuvemEnvioLabel: () => void;
}

function useDownloadNuvemEnvioLabel(): UseDownloadNuvemEnvioLabelResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioDownloadLabelsData);
  const status = useSelector(getNuvemEnvioDownloadLabelsStatus);

  const downloadNuvemEnvioLabel = useCallback(
    async (
      params: NuvemEnvioDownloadLabelsRequestDto,
    ): Promise<NuvemEnvioDownloadLabelsResponseDto> => {
      const response = await dispatch(
        downloadNuvemEnvioLabelAction(params),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetDownloadNuvemEnvioLabel = useCallback(() => {
    dispatch(resetDownloadNuvemEnvioLabelAction());
  }, [dispatch]);

  return {
    downloadNuvemEnvioLabel,
    data,
    status,
    resetDownloadNuvemEnvioLabel,
  };
}

export default useDownloadNuvemEnvioLabel;
